import r, { useState as p, useRef as q, useEffect as M } from "react";
import o from "prop-types";
import { get as s, last as N, isEmpty as R } from "lodash";
import x from "react-resize-observer";
import z from "react-responsive";
import g from "classnames";
import { I as C } from "./Icon-BuIPTPJn.es.js";
import { I as P } from "./IconButton-CJS1GKeN.es.js";
import './MediaViewer.css';const E = ({
  alt: e,
  src: l,
  placeholderImage: n,
  errorImage: m,
  ...c
}) => {
  const [d, w] = p(!1);
  return /* @__PURE__ */ r.createElement(
    "img",
    {
      ...c,
      alt: e,
      src: d ? m : l || n,
      onError: () => w(!0)
    }
  );
};
E.propTypes = {
  /** alt text */
  alt: o.string.isRequired,
  /** url source of image */
  src: o.string,
  /** Image to be displayed during loading */
  placeholderImage: o.string.isRequired,
  /** Image to be displayed during errors */
  errorImage: o.string.isRequired
};
E.defaultProps = {
  src: void 0
};
const h = (e) => /* @__PURE__ */ r.createElement(E, { key: e.src || "no-src", ...e });
h.propTypes = {
  /** url source of image */
  src: o.string,
  /** Image to be displayed during loading */
  placeholderImage: o.string.isRequired,
  /** Image to be displayed during errors */
  errorImage: o.string.isRequired
};
h.defaultProps = {
  src: void 0
};
const H = (e) => !R(e.mimetype) && e.mimetype.indexOf("video/") !== -1, L = (e) => {
  let l;
  if (H(e)) {
    const n = s(e, "storyboard", []), m = s(e, "extra", []);
    n.length === 0 ? l = s(m[0], "thumbnail.url") : l = s(N(n), "thumbnail.url");
  } else
    l = s(e, "thumbnail.url") || s(e, "url");
  return l;
}, S = "MediaViewer-module__wide___u7kw4", Q = "MediaViewer-module__narrow___QFrZs", W = "MediaViewer-module__active___PQTf4", t = {
  "thumbnail-list-arrow-color": "#666",
  "arrow-icon-size": "20px",
  "desktop-breakpoint": "1200px",
  "thumbnail-list-container": "MediaViewer-module__thumbnail-list-container___mqnqn",
  "thumbnail-list": "MediaViewer-module__thumbnail-list___1nGZC",
  "arrow-icon": "MediaViewer-module__arrow-icon___8Esdi",
  "media-viewer": "MediaViewer-module__media-viewer___-IpzQ",
  wide: S,
  "media-viewer-image": "MediaViewer-module__media-viewer-image___-TsEu",
  "thumbnail-listitem": "MediaViewer-module__thumbnail-listitem___DVk3Q",
  narrow: Q,
  "media-thumbnail-button": "MediaViewer-module__media-thumbnail-button___cM7Cf",
  active: W,
  "media-thumbnail-image": "MediaViewer-module__media-thumbnail-image___u1dAZ"
}, I = ({
  mediaItem: e,
  name: l,
  errorImage: n,
  placeholderImage: m
}) => {
  const { mimetype: c } = e;
  return !R(c) && c.indexOf("video/") !== -1 ? /* @__PURE__ */ r.createElement("video", { key: e.url, controls: !0, "aria-label": "video player" }, /* @__PURE__ */ r.createElement("source", { src: e.url, type: c }), /* @__PURE__ */ r.createElement("track", { src: s(e, "captionUrl", ""), kind: "captions" })) : /* @__PURE__ */ r.createElement(
    h,
    {
      alt: l,
      src: e.url,
      errorImage: n,
      placeholderImage: m
    }
  );
};
I.propTypes = {
  name: o.string.isRequired,
  // eslint-disable-next-line
  mediaItem: o.object.isRequired,
  errorImage: o.string.isRequired,
  placeholderImage: o.string.isRequired
};
const F = ({ og: e, errorImage: l, placeholderImage: n }) => {
  const [m, c] = p(!1), [d, w] = p(!1), [y, f] = p(0), _ = q(null);
  M(() => {
    f(0);
  }, [e]);
  const k = () => {
    const i = _.current;
    if (i !== null) {
      const a = i.scrollTop !== i.scrollHeight - i.offsetHeight, u = i.scrollLeft !== i.scrollWidth - i.offsetWidth;
      u !== d ? w(u) : a !== m && c(a);
    }
  }, b = (i) => {
    let a = 0;
    i === "down" ? a = 50 : i === "up" && (a = -50), m && (_.current.scrollTop += a), d && (_.current.scrollLeft += a);
  }, v = [
    s(e.media, "main", {}),
    ...s(e.media, "extra", []),
    ...s(e.media, "main.storyboard", [])
  ], V = (i) => /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement("div", { className: t["media-viewer-image"] }, /* @__PURE__ */ r.createElement(
    I,
    {
      name: e.id,
      mediaItem: v[y],
      errorImage: l,
      placeholderImage: n
    }
  )), /* @__PURE__ */ r.createElement("div", { className: t["thumbnail-list-container"] }, i && /* @__PURE__ */ r.createElement(
    P,
    {
      onClick: () => b("up"),
      onKeyPress: (a) => a.which === "Enter" ? b("up") : null,
      tabIndex: 0,
      className: t["arrow-icon"],
      color: t["thumbnail-list-arrow-color"],
      size: t["arrow-icon-size"],
      name: "arrow_up"
    }
  ), /* @__PURE__ */ r.createElement("ul", { className: t["thumbnail-list"], ref: _ }, /* @__PURE__ */ r.createElement(
    x,
    {
      handleWidth: !0,
      handleHeight: !0,
      onResize: k,
      refreshMode: "debounce"
    }
  ), v.map((a, u) => /* @__PURE__ */ r.createElement(
    "li",
    {
      className: t["thumbnail-listitem"],
      key: a.url || u
    },
    /* @__PURE__ */ r.createElement(
      "button",
      {
        className: g(
          t["media-thumbnail-button"],
          {
            [t.active]: u === y
          }
        ),
        onClick: () => {
          f(u);
        },
        onKeyPress: (T) => {
          T.key === "Enter" && f(u);
        },
        type: "button"
      },
      /* @__PURE__ */ r.createElement(
        h,
        {
          alt: e.id,
          className: t["media-thumbnail-image"],
          src: L(a),
          errorImage: l,
          placeholderImage: n
        }
      )
    )
  ))), i && /* @__PURE__ */ r.createElement(
    "button",
    {
      onClick: () => b("down"),
      onKeyPress: (a) => a.which === "Enter" ? b("down") : null,
      tabIndex: 0,
      className: t["arrow-icon"],
      type: "button"
    },
    /* @__PURE__ */ r.createElement(
      C,
      {
        color: t["thumbnail-list-arrow-color"],
        size: t["arrow-icon-size"],
        name: "arrow_down"
      }
    )
  )));
  return /* @__PURE__ */ r.createElement(z, { maxWidth: t["desktop-breakpoint"] }, (i) => i ? /* @__PURE__ */ r.createElement(
    "div",
    {
      className: g(
        t["media-viewer"],
        t.narrow
      )
    },
    V(d)
  ) : /* @__PURE__ */ r.createElement(
    "div",
    {
      className: g(
        t["media-viewer"],
        t.wide
      )
    },
    V(m)
  ));
};
F.propTypes = {
  /** Observation group, including media information */
  // eslint-disable-next-line
  og: o.object.isRequired,
  /** Image to display if the MediaViewer errors our */
  errorImage: o.string.isRequired,
  /** Image to display when data is loading */
  placeholderImage: o.string.isRequired
};
export {
  F as M
};
